// extracted by mini-css-extract-plugin
module.exports = {"DetailTitle":"DetailTitle_DetailTitle__qICHC","TitleText":"DetailTitle_TitleText__fP_Mi"};